/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ChatMessage } from '../models/chat-message';
import { ChatModel } from '../models/chat-model';
import { ChatSession } from '../models/chat-session';
import { CreateChatSessionRequest } from '../models/create-chat-session-request';
import { SendChatMessageRequest } from '../models/send-chat-message-request';


/**
 * AI chat sessions scoped to an invoice.
 */
@Injectable({
  providedIn: 'root',
})
export class AiChatService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listChatModels
   */
  static readonly ListChatModelsPath = '/chat/models';

  /**
   * List available AI chat models.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listChatModels()` instead.
   *
   * This method doesn't expect any request body.
   */
  listChatModels$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
'models': Array<ChatModel>;
}>> {

    const rb = new RequestBuilder(this.rootUrl, AiChatService.ListChatModelsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'models': Array<ChatModel>;
        }>;
      })
    );
  }

  /**
   * List available AI chat models.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listChatModels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listChatModels(params?: {
    context?: HttpContext
  }
): Observable<{
'models': Array<ChatModel>;
}> {

    return this.listChatModels$Response(params).pipe(
      map((r: StrictHttpResponse<{
'models': Array<ChatModel>;
}>) => r.body as {
'models': Array<ChatModel>;
})
    );
  }

  /**
   * Path part for operation listChatSessions
   */
  static readonly ListChatSessionsPath = '/invoices/{id}/chat/sessions';

  /**
   * List chat sessions for an invoice.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listChatSessions()` instead.
   *
   * This method doesn't expect any request body.
   */
  listChatSessions$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<ChatSession>>> {

    const rb = new RequestBuilder(this.rootUrl, AiChatService.ListChatSessionsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ChatSession>>;
      })
    );
  }

  /**
   * List chat sessions for an invoice.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listChatSessions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listChatSessions(params: {
    id: number;
    context?: HttpContext
  }
): Observable<Array<ChatSession>> {

    return this.listChatSessions$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ChatSession>>) => r.body as Array<ChatSession>)
    );
  }

  /**
   * Path part for operation createChatSession
   */
  static readonly CreateChatSessionPath = '/invoices/{id}/chat/sessions';

  /**
   * Create a new AI chat session.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createChatSession()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createChatSession$Response(params: {
    id: number;
    context?: HttpContext
    body: CreateChatSessionRequest
  }
): Observable<StrictHttpResponse<ChatSession>> {

    const rb = new RequestBuilder(this.rootUrl, AiChatService.CreateChatSessionPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ChatSession>;
      })
    );
  }

  /**
   * Create a new AI chat session.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createChatSession$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createChatSession(params: {
    id: number;
    context?: HttpContext
    body: CreateChatSessionRequest
  }
): Observable<ChatSession> {

    return this.createChatSession$Response(params).pipe(
      map((r: StrictHttpResponse<ChatSession>) => r.body as ChatSession)
    );
  }

  /**
   * Path part for operation getChatSession
   */
  static readonly GetChatSessionPath = '/invoices/{id}/chat/sessions/{sessionId}';

  /**
   * Get chat session history.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getChatSession()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChatSession$Response(params: {
    id: number;
    sessionId: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
'session': ChatSession;
'messages': Array<ChatMessage>;
}>> {

    const rb = new RequestBuilder(this.rootUrl, AiChatService.GetChatSessionPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('sessionId', params.sessionId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'session': ChatSession;
        'messages': Array<ChatMessage>;
        }>;
      })
    );
  }

  /**
   * Get chat session history.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getChatSession$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getChatSession(params: {
    id: number;
    sessionId: string;
    context?: HttpContext
  }
): Observable<{
'session': ChatSession;
'messages': Array<ChatMessage>;
}> {

    return this.getChatSession$Response(params).pipe(
      map((r: StrictHttpResponse<{
'session': ChatSession;
'messages': Array<ChatMessage>;
}>) => r.body as {
'session': ChatSession;
'messages': Array<ChatMessage>;
})
    );
  }

  /**
   * Path part for operation sendChatMessage
   */
  static readonly SendChatMessagePath = '/invoices/{id}/chat/sessions/{sessionId}/messages';

  /**
   * Send a message to the AI.
   *
   * Returns a stream of SSE events
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendChatMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendChatMessage$Response(params: {
    id: number;
    sessionId: string;
    context?: HttpContext
    body: SendChatMessageRequest
  }
): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, AiChatService.SendChatMessagePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('sessionId', params.sessionId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/event-stream',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Send a message to the AI.
   *
   * Returns a stream of SSE events
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendChatMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendChatMessage(params: {
    id: number;
    sessionId: string;
    context?: HttpContext
    body: SendChatMessageRequest
  }
): Observable<string> {

    return this.sendChatMessage$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
